define ['./finicity_connect_modal.scss'], () ->
  ($scope, $state, $stateParams, $rootScope, $http, RENTAPPLICATION_API_URL, $uibModalInstance, Raven) ->
    $scope.is_script_loading = false
    $scope.events = []

    $scope.close_modal = (next) ->
      $uibModalInstance.close(next)
    
    $scope.load_finicity_iframe = () ->
      window.finicityConnect.launch($scope.connect_url, {
        selector: "#connect-container",
        success: (event) ->
          $scope.events.push(event)
          Raven.captureMessage('Finicity Connect success', {
            level: 'info',
            extra: {
              events: $scope.events
            }
          })
          $scope.close_modal(true)
        ,
        cancel: (event) ->
          $scope.events.push(event)
          Raven.captureMessage('Finicity Connect cancel', {
            level: 'info',
            extra: {
              events: $scope.events
            }
          })
          $scope.close_modal(false)
        ,
        error: (error) ->
          $scope.events.push(error)
          Raven.captureMessage('Finicity Connect error', {
            level: 'info',
            extra: {
              events: events
            }
          })
        ,
        loaded: (event) ->
          $scope.events.push(event)
        ,
        route: (event) ->
          $scope.events.push(event)
        ,
        user: (event) ->
          $scope.events.push(event)
      })

    $scope.load_finicity_connect_script = () ->
      script = document.createElement("script")
      $scope.is_script_loading = true
      
      script.onload = () ->
        $scope.is_script_loading = false
        $scope.load_finicity_iframe()
      
      script.async = true
      script.src =
        "https://connect2.finicity.com/assets/sdk/finicity-connect.min.js"
      document.head.appendChild(script)
    
    # Everytime this modal is open, we
    # reload finicity connect instance
    # so this should always be initiated
    if !window.finicityConnect
      $scope.load_finicity_connect_script()
    else
      setTimeout(() -> 
        $scope.load_finicity_iframe()
      , 100)
    


// WEBPACK FOOTER //
// ./components/applications/income/finicity_connect_modal.coffee